module.exports = __webpack_public_path__ + "static/media/clear.2f359678.mp3";